module.exports = __webpack_public_path__ + "img/brand.495c719a.svg";